import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow database tokens.
 */
export class DatabaseTokenOperations {
  constructor(private client: BaserowClient) {}
  
  // Database token methods will be implemented here
} 